module.exports = __webpack_public_path__ + "static/media/logo-levo.39a8c633.svg";